import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const setSalaryBracketMutation = gql`
  mutation SetSalaryBracket($salaryBracketId: ID!, $payrollFrequency: String!) {
    setSalaryBracket(input: {salaryBracketId: $salaryBracketId, payrollFrequency: $payrollFrequency}) {
      salaryBracketId
      errors
    }
  }
`
export const setSalaryBracketMutationKey = getQueryNames(setSalaryBracketMutation)[0]
export {setSalaryBracketMutation}
